import { createReducer } from "./functions";

import { SET_LIMITS_BONUSES_LIST, SET_PREMIUM_LIST, SET_REGULAR_BONUSES_LIST } from "../types";

const initialState = {
  premiumList: [],
  bonusesLimitsList: [],
  regularBonusesList: []
};

const setPremiumList = {
  [SET_PREMIUM_LIST]: (state, action) => {
    return { ...state, premiumList: action.payload };
  }
};
const setLimitsBonusesList = {
  [SET_LIMITS_BONUSES_LIST]: (state, action) => {
    return { ...state, bonusesLimitsList: action.payload };
  }
};
const setRegularBonusesList = {
  [SET_REGULAR_BONUSES_LIST]: (state, action) => {
    return { ...state, regularBonusesList: action.payload };
  }
};
const premiumReducer = createReducer(initialState, {
  ...setPremiumList,
  ...setRegularBonusesList,
  ...setLimitsBonusesList
});

export default premiumReducer;



// WEBPACK FOOTER //
// src/redux/reducers/premiumReducer.js